import React, { Component } from 'react'
import CollapsibleTile from '../../../components/CollapsibleTile';
import { APIData } from '../../../constants/APIAdresses';
import GenericTable from '../../../components/GenericTable/GenericTable';
import { GD_MODE, GENERIC_DRAWER_TYPE } from '../../../components/GenericDrawer';
import EntitySelectionContent from '../../../components/EntitySelection/EntitySelectionContent';
import { ALERT_SEVERITY } from '../../../components/AlertDisplay2';
import GiftCardDialog from './GiftCardDialog';
import { Button } from '@mui/material';
import CustomLightButton from '../../../components/CustomLightButton';
import GiftCardLedgerDialog from './GiftCardLedgerDialog';

const giftcardColumns = [
    // {
    //     width: 150,
    //     label: 'ID',
    //     // baseImgUri: APIData.MEDIA,
    //     dataKey: 'ID',
    // },
    {
        width: 50,
        label: 'ID',
        dataKey: 'id',
    },
    {
        // width: 2,
        label: 'Code',
        dataKey: 'codeLastDigits',
        format: (value) => { return value != null ? "****-****-****-" + value : "-" }
    },
    {
        // width:2,
        label: 'Gültig bis',
        dataKey: 'expiresAt',
        format: (value) => { return value != null ? new Date(value).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }) : "-" }
    }
]

export class GiftcardTile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dialogOpen: false,
            ledgerDialogOpen: false,
            giftCards: [],
            editMode: false, // there is never an edit mode for gift cards
            selectedShopIds: [{ id: parseInt(props.shopId) }] // since gift cards are always created for a specific shop, we can already set the shop id as selected for the entity selection
        }
    }
    onSave(configData) {

    }
    filterEntitySelectionResults(result) {
        const { editMode } = this.state;
        if (!editMode) {
            return result.map(item => {
                const { added, ...rest } = item;
                return rest;
            }).filter(item => item.deselected !== true); // also remove deselected ones in creation mode, since they are not relevant at all
        }
        return result;
    }
    render() {

        const { shopId, companyId, openDrawer, closeDrawer } = this.props;
        // const GC_BASE_DRAWERCONFIGDATA = {
        //     options: [
        //         { label: "Speichern", onclick: (data) => { this.onSave(data) } },
        //         { label: "Abbrechen", color: "error", onClick: () => { console.log("Abbrechen..."); closeDrawer() } }
        //     ],
        //     fields: [
        //         {
        //             label: "Code",
        //             type: GENERIC_DRAWER_TYPE.TEXT,
        //         },
        //         {
        //             label: "Gültig bis",
        //             type: GENERIC_DRAWER_TYPE.DATE,
        //         },
        //         {
        //             label: 'Anzahl (max. 10)',
        //             type: GENERIC_DRAWER_TYPE.INTEGER_AMOUNT,
        //             value: 1,
        //             minValue: 1,
        //             maxValue: 10,
        //         },
        //         {
        //             label: "Nur Ausgewählte Shops",
        //             type: GENERIC_DRAWER_TYPE.SWITCH,
        //             value: true,
        //             onUpdateCallback: (value) => {
        //                 if (!value) {
        //                     this.setState({ selectedShopIds: [] });
        //                 } else {
        //                     this.setState({ selectedShopIds: [{ id: shopId }] });
        //                 }
        //             }
        //         },
        //         {
        //             label: 'Shops',
        //             type: GENERIC_DRAWER_TYPE.CUSTOM,
        //             customComponent: <div style={{ marginTop: 15 }}>
        //                 <EntitySelectionContent
        //                     title="Shops auswählen"
        //                     icon={require('../../../assets/icons/store.png')}
        //                     apiEndpoint={(page, ipp, search) => `${APIData.SHOP}/getShopsPaginated?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}&companyId=${companyId}`}
        //                     method="GET"
        //                     body={undefined}
        //                     keyFieldName="id"
        //                     multipleSelection={true}
        //                     deselectionDisabled={this.state.editMode}
        //                     value={this.state.selectedShopIds}
        //                     searchPlaceholder="Suche"
        //                     additionalKeysToAdd={[]}
        //                     onChange={(selectedItems) => {
        //                         const finalItems = this.filterEntitySelectionResults(selectedItems);
        //                         if (finalItems?.length > 0) {
        //                             this.setState({
        //                                 selectedShopIds: finalItems
        //                             });
        //                         } else {
        //                             this.props.showAlert("Letzte Shop kann nicht gelöscht werden!", ALERT_SEVERITY.WARNING);
        //                         }
        //                     }}
        //                     renderChipContent={(item) => (
        //                         <div style={{ flex: 1 }}>
        //                             <div
        //                                 style={{
        //                                     fontSize: "0.95rem",
        //                                     color: "#353535"
        //                                 }}
        //                             >
        //                                 <span style={{ fontWeight: 600 }}>
        //                                     Shop:
        //                                 </span>{" "}
        //                                 {item.name}{" "}
        //                                 <span style={{ fontWeight: 600 }}>
        //                                     ID:
        //                                 </span>{" "}
        //                                 ({item.id})
        //                             </div>

        //                             <div
        //                                 style={{
        //                                     fontSize: "0.9rem",
        //                                     color: "#676767"
        //                                 }}
        //                             >
        //                                 Adresse: {item.street} {item.houseNumber},{" "}
        //                                 {item.zip} {item.city}
        //                             </div>
        //                         </div>
        //                     )}
        //                 />
        //             </div>
        //         }
        //     ]
        // }
        return (
            <CollapsibleTile title="Gutscheinkarten"
                isLoading={this.state.loading}
                onCollapseChange={(isExpanded, firstExpand) => {
                    console.log("ONCOLLAPSE???")
                    if (isExpanded && firstExpand) {
                        // this.loadOpeningHours();
                    }
                }}
                icon={<img src={require('../../../assets/icons/giftbox_64x.png')} width={20} height={20} />}>
                <GenericTable
                    activeKey="isActive"
                    setProductActive={(index) => {
                        console.log("TOGGLE ACTIVE: ", index);
                    }}
                    addBtnLabel="Gutscheinkarte hinzufügen"
                    addBtnOnClick={() => {
                        // since no edit is possible here, we dont have to set any indexes
                        // const fields = [...this.drawerConfigBaseFields.fields];
                        // fields.push(this.shopConfigField);
                        // openDrawer({
                        //     options: this.drawerConfigBaseFields.options,
                        //     fields: fields
                        // }, GD_MODE.NEW);
                        // this.setState({ selectedProductIndex: -1 }) 
                        this.setState({ dialogOpen: true });
                    }}
                    apiEndPoint={APIData.USER + `/giftcard/getAll?shopId=${shopId}`}
                    tableData={this.state.giftCards}
                    setTableData={(data) => { this.setState({ giftCards: data }) }}
                    // onClickRow={(index) => {
                    //     // this.setState({ selectedProductIndex: index })
                    // }}
                    config={{ columns: giftcardColumns }}
                />
                <CustomLightButton label="Historie" onClick={() => { this.setState({ ledgerDialogOpen: true }) }} icon={require('../../../assets/icons/ledger.png')} />
                {this.state.ledgerDialogOpen && (
                    <GiftCardLedgerDialog shopId={shopId} companyId={companyId} open={this.state.ledgerDialogOpen} title={`Historie`} onClose={() => { this.setState({ ledgerDialogOpen: false }) }} showAlert={(msg, severity) => { this.props.showAlert(msg, severity) }} />
                )}
                {this.state.dialogOpen && (
                    <GiftCardDialog shopId={shopId} companyId={companyId} open={this.state.dialogOpen} title="Gutscheinkarte erstellen"
                        onClose={() => { this.setState({ dialogOpen: false }) }}
                        showAlert={(msg, severity) => { this.props.showAlert(msg, severity) }}
                    />
                )}
            </CollapsibleTile>
        )
    }
}

export default GiftcardTile